import { render, staticRenderFns } from "./WizardSteps.vue?vue&type=template&id=528a1c22&scoped=true"
import script from "./WizardSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardSteps.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardSteps.vue?vue&type=style&index=0&id=528a1c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a1c22",
  null
  
)

export default component.exports